export default __webpack_public_path__ + "static/media/texo-logo.db94fbfe.png";